import React, { Component } from 'react';
import { compose } from 'redux';
import { withApollo } from "react-apollo";
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { notification } from 'antd';

import ReleaseForm from './components/ReleaseForm';
import { history } from '../store';

import withGraphqlData from '../shared/components/withGraphqlData';
import { parseFormErrors } from '../shared/utils/form_errors';
import {
  CreateReleaseFormOptionsQuery,
  CreateModelTagMutation,
  CreateReleaseMutation
} from './queries';

class NewRelease extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTagCreate = this.handleTagCreate.bind(this);
  }

  handleSubmit({ hasStringPrice, ...data }) {
    const { client } = this.props;

    const buyLinks = (data.buyLinks || []).filter(
      (row) => row && (String(row.title || '').trim() || String(row.link || '').trim()),
    );
    const raffleLinks = (data.raffleLinks || []).filter(
      (row) => row && (row.raffleId || String(row.link || '').trim()),
    );

    const record = {
      ...data,
      imageUrls: (data.imageUrls || []).filter(Boolean),
      buyLinks,
      raffleLinks,
      resellUrls: (data.resellUrls || []).filter(Boolean),
    };

    delete record.comments;

    Object.keys(record).forEach((key) => {
      if (record[key] === undefined) delete record[key];
    });

    return client
      .mutate({
        mutation: CreateReleaseMutation,
        variables: { record },
        errorPolicy: 'all',
      })
      .then((result) => {
        const errs = result && result.errors;
        if (errs && errs.length) {
          throw Object.assign(new Error(errs.map((e) => e.message).join(' ')), {
            graphQLErrors: errs,
          });
        }
        const id = result && result.data && result.data.createRelease && result.data.createRelease._id;
        if (!id) {
          throw new Error('Create release did not return an id.');
        }
        history.push('/releases');
      })
      .catch(parseFormErrors);
  }

  async handleTagCreate(newTagWord) {
    const { client, data: { refetch } } = this.props;

    let newTag = null

    await client.mutate({
      mutation: CreateModelTagMutation,
      variables: { keyword: { title: newTagWord } },
    })
    .then((response) => {
      refetch();
      newTag = response.data.createModelTag
    })
    .catch(error => {
      if (error.message.endsWith("Validation failed")) {
        return notification.error({ message: "Tag is already exists" });
      }
      notification.error(error);
    });

    return newTag
  }

  render() {
    const { ModelBrands, ModelTags, SneakerModels, Raffles } = this.props.data;

    return (
      <div id="new-release">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/releases">Releases</Link></Breadcrumb.Item>
          <Breadcrumb.Item>New Release</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <ReleaseForm
            onSubmit={this.handleSubmit}
            tagCreateHandler={this.handleTagCreate}
            brands={ModelBrands}
            tags={ModelTags}
            sneakerModels={SneakerModels}
            raffles={Raffles}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withGraphqlData(CreateReleaseFormOptionsQuery),
  withApollo,
)(NewRelease);
